import "./MeetKira.module.css";
import MainNavigation from "@/reusable_sections/Header";
import TheStoryBehindTheCoach from "./sections/TheStoryBehindTheCoach";
import MyPhilosophy from "./sections/MyPhilosophy";
import ExpertiseCredentials from "./sections/ExpertiseCredentials";
import FooterEssentials from "@/reusable_sections/Footer";
export default function MeetKiraPage() {
  return <div>
      <MainNavigation />
      <TheStoryBehindTheCoach />
      <MyPhilosophy />
      <ExpertiseCredentials />
      <FooterEssentials />
    </div>;
}